<template>
  <div class="ioscancel">
    <div class="block">
      <p class="block-p"><span style="color:skyblue">1. </span>打开 App Store</p>
      <img class="one img" src="../assets/cosleep_guidance_img_subscribe1_cn@3x.png"/>
    </div>
    <div class="block">
      <p class="block-p"><span style="color:skyblue">2. </span>点击右上角进入“个人中心”</p>
      <img class="two img" src="../assets/cosleep_guidance_img_subscribe2_cn@3x.png"/>
    </div>
    <div class="block">
      <p class="block-p"><span style="color:skyblue">3. </span>点击进入个人账户</p>
      <img class="two img" src="../assets/cosleep_guidance_img_subscribe3_cn@3x.png"/>
    </div>
    <div class="block">
      <p class="block-p"><span style="color:skyblue">4. </span>在账户设置页面点击“订阅”</p>
      <img class="two img" src="../assets/cosleep_guidance_img_subscribe4_cn@3x.png"/>
    </div>
    <div class="block">
      <p class="block-p"><span style="color:skyblue">5. </span>选择“小睡眠”，点击“取消订阅”关闭自动续费</p>
      <img class="two img" src="../assets/cosleep_guidance_img_subscribe5_cn@3x.png"/>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ioscancel',
  mounted () {
    document.title = 'ios取消连续包月'
  }
}
</script>

<style lang="scss" scoped>
.ioscancel {
  font-family: Noto Sans CJK SC Regular;
  font-size: px2html(14px);
  box-sizing: border-box;
  margin-top: px2html(20px);
  padding-left: px2html(21px);
  padding-right: px2html(21px);
  .block {
    text-align: left;
    position: relative;
    margin-bottom: px2html(30px);
  }
  .img {
    margin-top: px2html(10px);
    position: relative;
    right: px2html(-20px);
  }
  .one {
    width: px2html(60px);
    height: px2html(75px);
  }
  .two {
    width: px2html(140px);
    height: px2html(231px);
  }
}
</style>
